import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import TextInput from 'components/forms/TextInput';

import cxHelpers from 'util/className';
import { toI18n } from 'util/i18n';
import { createKeyPressHandler } from 'util/keybindings';

@cxHelpers('ApplicantMessengerMessageForm')
export default class ApplicantMessengerMessageForm extends PureComponent {
  static propTypes = {
    onResetPrefill: PropTypes.func,
    onSend: PropTypes.func.isRequired,
    prefillMessage: PropTypes.string,
  };

  state = {
    message: '',
    controlMetaPressed: false,
  };

  // TODO: https://joinhomebase.atlassian.net/browse/HIRING-441
  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextPrefillMessage = nextProps.prefillMessage;
    if (nextPrefillMessage && nextPrefillMessage !== this.state.message) {
      this.setState({ message: nextPrefillMessage });
    }
  }

  componentWillUnmount() {
    if (this.props.onResetPrefill) {
      this.props.onResetPrefill();
    }
  }

  handleControlMetaPressed = () => this.setState({ controlMetaPressed: true });

  handleControlMetaReleased = () =>
    this.setState({ controlMetaPressed: false });

  handleEnterPressed = () => {
    if (this.state.controlMetaPressed) {
      this.handleSendMessage();
    }
  };

  handleKeyDown = createKeyPressHandler({
    Control: this.handleControlMetaPressed,
    Enter: this.handleEnterPressed,
    Meta: this.handleControlMetaPressed,
  });

  handleKeyUp = createKeyPressHandler({
    Control: this.handleControlMetaReleased,
    Meta: this.handleControlMetaReleased,
  });

  handleSendMessage = () => {
    this.props.onSend({ message: this.state.message });
    this.setState({ message: '' });
    this.resetPrefill();

    if (this.inputRef && this.inputRef.focus) {
      this.inputRef.focus();
    }
  };

  resetPrefill = () => {
    if (this.props.onResetPrefill && this.props.prefillMessage) {
      this.props.onResetPrefill();
    }
  };

  handleMessageChange = message => {
    this.setState({ message });
    this.resetPrefill();
  };

  getInputRef = input => {
    this.inputRef = input;
  };

  render() {
    const { message } = this.state;
    return (
      <Box className={this.cx()} bt>
        <TextInput
          className={this.cxEl('text-input')}
          border={false}
          getInputRef={this.getInputRef}
          onChange={this.handleMessageChange}
          onKeyDown={this.handleKeyDown}
          onKeyUp={this.handleKeyUp}
          placeholder={toI18n(
            'hiring.application_messaging.message_form.placeholder'
          )}
          type="textarea"
          value={message}
          valueOnChange
        />
        <Box paxs>
          <Button
            fullWidth
            theme="primary"
            disabled={!message}
            onClick={this.handleSendMessage}
            i18n="hiring.application_messaging.message_form.send"
          />
        </Box>
      </Box>
    );
  }
}
